import React from 'react'
import CSSModules from 'react-css-modules'
import Navigation from 'react-toolbox/lib/navigation'
import Link from 'react-toolbox/lib/link'

import Divider from 'components/fulcrum/divider/Divider'

import theme from './FilterNavHeader.scss'

const FilterNavHeader = (props) => (
  <Navigation theme={theme} type='vertical'>
    <h5 class={theme.header}>Product Category</h5>
    <Divider class={theme.divider}/>
    { props.children }
  </Navigation>
)
export default CSSModules(FilterNavHeader, theme)
